import React from "react";
import CreateUserForm from "../components/CreateUserForm";

function AdminUsers() {
  return <CreateUserForm />;
}

export default AdminUsers;
